import React, { useState, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import { allFeatured, getFeatured } from '../../reducers/catalog';
import FeaturedProduct from "./FeaturedProduct";
import { getSubsite } from '../../reducers/auth';
import SubsiteService from "../../services/subsite.service";
import AdminService from "../../services/admin.service";
import {Container, Row} from 'react-bootstrap';

const BACKEND_URL = process.env.REACT_APP_LOCALHOST_URL;

const AdminFeatured = () => {
  const dispatch = useDispatch();
  const featured = useSelector(allFeatured);
  const featuredStatus = useSelector(state => state.catalog.featuredStatus);
  const currentSubsite = useSelector(getSubsite);
  const [featuredContent, setFeaturedContent]  = useState(<Spinner text="Loading..." />);


  const [content, setContent] = useState('');

  useEffect(() => {
    async function fetchData() {
      var content = await SubsiteService.getHomepageContent();
      console.log("CONTENT", content);
      setContent(content);
      //var shipping = await ShippingService.getShipping();
      //console.log("SHIPPING", shipping);
      dispatch(getFeatured());
    }
    fetchData();   
  }, []);

  useEffect(() => {
    console.log("Get FEATURED");
    if (featuredStatus === 'idle') {
      dispatch(getFeatured());
    } else if (featuredStatus === 'succeeded') {
      console.log("FEATUREDDD", featured);
      setFeaturedContent(featured.map(featuredItem => (
          <FeaturedProduct key={featuredItem.isPrintItem ? `print_${featuredItem.id}` : `product_${featuredItem.id}`} product={featuredItem} featured removeFeaturedItem={removeFeaturedItem}/>
      )));
    } else if (featuredStatus === 'failed') {
      setFeaturedContent(<div>error</div>);
    }
  }, [featuredStatus, dispatch]);
  
  const removeFeaturedItem = async(id, isPrintItem = false) => {
    console.log("REMOVE", id);
    var status = isPrintItem
      ? await AdminService.removePrintItemFeatured(id)
      : await AdminService.removeFeatured(id);
    if(status.error){
        console.log("ERROR", status.error);
    } else {
        dispatch(getFeatured());
    }
  }

  console.log("AFTER Content");

  return (
    <Container>
        <h2>Featured Items</h2>
        <div style={{padding: 30}}>
        <Container>
          <Row>
            { featuredContent }
          </Row>
        </Container>
      </div>
    </Container>
  );
};
export default AdminFeatured;